import React, {useContext} from 'react';
import {StoreContext} from './root-store';
import {Grid, GridColumn, Progress} from '../../../patterns';
import {formatToDayMonthAndYear} from './dateUtils';
import {Datapoint, Period} from '../dashboard/team-results-store';

export interface IScoreTooltipProps {
    period: Period;
    name?: string;
    categoryName?: string;
    compareToName?: string
    value: Datapoint;
    compareTo?: Datapoint;
}

export const ScoreTooltip = (props: IScoreTooltipProps): JSX.Element => {
    const store = useContext(StoreContext).labelStore;
    const compareToScore = props.compareTo ? props.compareTo.scorePercentage : 50;
    const score = props.value.scorePercentage;
    const gridColumnWidth = props.compareToName ? 'xs-6' : 'xs-12';

    return (
        <div className="text">
            <div className="bold">{formatToDayMonthAndYear(props.period.from)} - {formatToDayMonthAndYear(props.period.to)}</div>
            <Grid gutter='small' verticalGutter='none'>
                {props.name && <GridColumn width={[gridColumnWidth]}>{props.name}</GridColumn>}
                {props.categoryName && <GridColumn width={[gridColumnWidth]}>{props.categoryName}</GridColumn>}
                {props.compareToName && <GridColumn width={[gridColumnWidth]}>{props.compareToName}</GridColumn>}
            </Grid>
            <Grid gutter='small' verticalGutter='none'>
                <GridColumn width={[gridColumnWidth]}>
                    <Progress
                        icon='like'
                        color={score >= compareToScore ? 'green' : 'red'}
                        label={store.label('dashboard.tooltip.score', {score_percentage: score.toString()})}
                        percent={score}
                    />
                </GridColumn>
                {props.compareTo && <GridColumn width={[gridColumnWidth]}>
                    <Progress
                        icon='like'
                        color={compareToScore >= score ? 'green' : 'red'}
                        label={store.label('dashboard.tooltip.score', {score_percentage: compareToScore.toString()})}
                        percent={compareToScore}
                    />
                </GridColumn>}
            </Grid>
            <Grid gutter='small' verticalGutter='none'>
                <GridColumn width={[gridColumnWidth]}>
                    <Progress
                        icon='users'
                        color='blue'
                        label={store.label('dashboard.tooltip.activity-percentage', {
                            answers_percentage: props.value.participationPercentage.toString(),
                        })}
                        percent={props.value.participationPercentage}
                    />
                </GridColumn>
                {props.compareTo && <GridColumn width={[gridColumnWidth]}>
                    <Progress
                        icon='users'
                        color='blue'
                        label={store.label('dashboard.tooltip.activity-percentage', {
                            answers_percentage: props.compareTo.participationPercentage.toString(),
                        })}
                        percent={props.compareTo.participationPercentage}
                    />
                </GridColumn>}
            </Grid>
        </div>
    );
};
